import { Endpoint } from "../config";

export type TodoEndpointType = "todo" | "todoById";

export const todoEndpoints: Record<TodoEndpointType, Endpoint> = {
  todo: {
    url: "todo/",
  },
  todoById: {
    url: "todo",
  },
};
